// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import ManagePurchaseOrder from '@/components/purchase/manage';
import * as Enums from '@/utils/enums';
import Fetch from '@/utils/Fetch';
import BillingService from '@/services/billing-service';
import Helper from '@/utils/helper';
import Router, { useRouter } from 'next/router';
import SubscriptionContext from '@/utils/subscription-context';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

function CreatePurchaseOrder() {
  const router = useRouter();
  const { id, module, moduleID, rootModule, supplierID } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

  const subscriptionContext = useContext(SubscriptionContext);
  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const { data: copyFromPurchaseOrder } = useQuery(
    ['purchaseOrder', id],
    () => Fetch.get({ url: `/PurchaseOrder/${id}` }),
    { enabled: !!id }
  );

  const { data: company } = useQuery(
    ['company'],
    () => Fetch.get({ url: '/Company' })
  );

  const getAccessStatus = async () => {
    const [subscriptionInfo] = await BillingService.getSubcriptionInfo(subscriptionContext);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  if (!company) return null;
  if (id && !copyFromPurchaseOrder) return null;

  return (
    <div>
      <ManagePurchaseOrder
        isNew={true}
        copyFromPurchaseOrder={copyFromPurchaseOrder}
        module={module}
        moduleID={moduleID}
        rootModule={rootModule}
        supplierID={supplierID}
        accessStatus={accessStatus}
        company={company}
      />
    </div>
  );
}

export default CreatePurchaseOrder;

export const Route = createFileRoute('/_authenticated/purchase/create')({ component: CreatePurchaseOrder })
